import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { getHaloPhotos } from 'app/shared/halo/utils/getHaloPhotos';
import { MediaCenterContent } from './MediaCenterContent';
import type { MediaCenterTab } from './MediaCenterTabs';

type MediaCenterPanelProps = {
  config?: unknown;
};

export const MediaCenterPanel = ({ config }: MediaCenterPanelProps) => {
  const listing = useSelector(
    (state: RootReduxState) =>
      state.currentListingDetails.currentListing || state.listings.listingGroups.previewListing,
  );

  const photos = getHaloPhotos(listing);
  const tourUrls = (listing as unknown as { details?: { tourUrls?: Array<string> } })?.details?.tourUrls || [];
  const tourLabels = (listing as unknown as { details?: { tourLabels?: Array<string> } })?.details?.tourLabels || [];
  const has3dTour =
    (listing as unknown as { details?: { has3dTour?: boolean } })?.details?.has3dTour ||
    listing?.hasExternal3dTourUrls ||
    listing?.hasZillow3dTourUrls ||
    false;
  const listingVideos = listing?.listingVideos || [];
  const hasVideos = listingVideos.length > 0;

  const initialTab = (config as MediaCenterTab) || 'photos';

  return (
    <MediaCenterContent
      open={true}
      photos={photos}
      tourUrls={tourUrls}
      tourLabels={tourLabels}
      has3dTour={has3dTour}
      hasVideos={hasVideos}
      videos={listingVideos}
      previewPhoto={listing?.previewPhoto}
      initialTab={initialTab}
    />
  );
};
